export const CHARGE_CREATE = 'chargerCreate'
export const CHARGE_EDIT = 'chargeEdit'
export const CHARGE_DELETE = 'chargeDelete'
export const CHARGE_GET = 'chargeGet'
export const CHARGES_GET = 'chargesGet'
export const CHARGES_BM_GET = 'chargesBMGet'
export const CHARGES_SIMPLE_BM_GET = 'chargesSimpleBMGet'
export const CHARGE_SEARCH = 'chargeSearch'
export const CHARGE_ACTIVE = 'chargeActive'
export const CHARGE_INACTIVE = 'chargeInactive'